export default {
  liveWallet: {
    id: 'seller-invoices-your_wallet-live_wallet',
    defaultMessage: 'Your wallet balance',
  },
  liveWalletInfoText: {
    id: 'seller-invoices-your_wallet-live_wallet_info_text',
    defaultMessage:
      'This is the amount you currently have in your Back Market wallet.',
  },
  noWalletBalance: {
    id: 'seller-invoices-your_wallet-no_wallet_balance',
    defaultMessage: 'No wallet balance',
  },
}
